import { UserRoleName } from 'gen/graphql-type'
import {
  User_MedicineCategoryPolicy_ShowFragment,
  User_MedicineCategoryPolicy_ShowSidebarFragment,
} from './fragment.gen-graphql'
import { authorize, Authorize } from '../authorize'

export const canShow: Authorize<User_MedicineCategoryPolicy_ShowFragment> = user => {
  return authorize(user, [
    UserRoleName.Operator,
    UserRoleName.SystemOperator,
    UserRoleName.Pharmacist,
    UserRoleName.Consignor,
    UserRoleName.DoctorManager,
    UserRoleName.Developer,
    UserRoleName.CouponManager,
  ])
}

export const canShowSidebar: Authorize<User_MedicineCategoryPolicy_ShowSidebarFragment> = user => {
  return authorize(user, [
    UserRoleName.Operator,
    UserRoleName.SystemOperator,
    UserRoleName.Pharmacist,
    UserRoleName.Consignor,
    UserRoleName.DoctorManager,
    UserRoleName.Developer,
    UserRoleName.CouponManager,
  ])
}
